import Choice from "../Choice/Choice";
import ChoiceGroup from "../Choice/ChoiceGroup";
import { themed, mapComponentThemes } from "../themes";
import { checkboxTheme, checkboxGroupTheme } from "./themes";
export var CheckboxRoot = themed(Choice)(function (_ref) {
  var baseTheme = _ref.theme;
  return mapComponentThemes({
    name: 'Checkbox',
    theme: checkboxTheme(baseTheme)
  }, {
    name: 'Choice',
    theme: {}
  }, baseTheme);
});
export var CheckboxGroupRoot = themed(ChoiceGroup)(function (_ref2) {
  var baseTheme = _ref2.theme;
  return mapComponentThemes({
    name: 'CheckboxGroup',
    theme: checkboxGroupTheme(baseTheme)
  }, {
    name: 'ChoiceGroup',
    theme: {}
  }, baseTheme);
});